import { IUserResponse, SecurityRole } from '@getgreenline/homi-shared'

// Returns an object shaped for identify payload, e.g. { role: 'Manager' } or {}
export function getUserRoleForCompany(
  user: IUserResponse | undefined,
  companyId: number | undefined,
  securityRoles: SecurityRole[] | undefined,
): { role: string } | {} {
  if (!user || !companyId || !securityRoles) return {}

  const directCompanyAssignment = user.entityAssignments?.find(
    (userEntityAssignment) => userEntityAssignment.entity?.id === companyId && userEntityAssignment.securityRoleId != null,
  )

  const anyCompanyAssignment =
    directCompanyAssignment ||
    user.entityAssignments?.find(
      (userEntityAssignment) => userEntityAssignment.entity?.rootEntityId === companyId && userEntityAssignment.securityRoleId != null,
    )

  const roleId = anyCompanyAssignment?.securityRoleId ?? undefined
  const roleName = roleId ? securityRoles.find((securityRole) => securityRole.id === roleId)?.name : undefined

  return roleName ? { role: roleName } : {}
}
